import { useState } from 'react';
import { Text } from "@hangar/web-components/core/Text";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../hooks/i18n';
import * as S from './styles/TitleBlock.style';
import RemittanceInfoLine from './RemittanceInfoLine';
import { TitleBlockProps } from './types';
import { ConfirmationModal } from '../common/ConfirmationModal';

const TitleBlock = ({ title, branchNumber, onBack, hasUnsavedChanges }: TitleBlockProps) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [showExitModal, setShowExitModal] = useState(false);

    const handleBack = () => {
      if (hasUnsavedChanges?.()) {
        setShowExitModal(true);
      } else {
        handleConfirmExit();
      }
    };

    const handleConfirmExit = () => {
        setShowExitModal(false);
        if (onBack) {
            onBack();
        } else {
            navigate('/dashboard');
        }
    };

    const handleCancelExit = () => {
        setShowExitModal(false);
    };

    return (
        <>
            <S.Container>
                <S.BackButton>
                    <span 
                        onClick={handleBack} 
                        onKeyDown={(e) => e.key === 'Enter' && handleBack()}
                        role="button"
                        tabIndex={0}
                    >
                        ← {t("navigation.backToList")}
                    </span>
                </S.BackButton>
                <S.TitleContainer>
                    <S.HeaderTitle><Text variant="heading-lg" bold>{title}</Text></S.HeaderTitle>
                </S.TitleContainer>
                <RemittanceInfoLine branchNumber={branchNumber} />
            </S.Container>

            <ConfirmationModal
                isOpen={showExitModal}
                title={t('flightChangeDetails.closeConfirmation.title')}
                message={t('flightChangeDetails.closeConfirmation.message')}
                confirmLabel={t('flightChangeDetails.closeConfirmation.confirm')}
                cancelLabel={t('flightChangeDetails.closeConfirmation.cancel')}
                onConfirm={handleConfirmExit}
                onCancel={handleCancelExit}
            />
        </>
    );
};

export default TitleBlock;
